module.exports = __webpack_public_path__ + "img/caas1-m@1.aa27f5ce.webp";